import React, { useState, useEffect } from 'react';
import { Grid, GridColumn as Column, GridNoRecords } from '@progress/kendo-react-grid';
import { useTranslation } from "react-i18next";
import cellActions from '../gridHL/CellActions.pure';
import "./gridSelectionHL.pure.css";


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const GridSelectionHLPure = (props) => {
    const {
        skip, //Number pagination {0}
        take, //Number pagination {6}
        dataGrid, //Array information to grid
        filter, //True to filter grid
        onFilterChange, //Filter function to grid
        onSelectedItem, //Select information item grid
        columnOne = true, //You need the frist column boolean, true active third column
        columnTwo, //You need the second column boolean, true active third column
        columnThree, //You need the third column boolean, true active third column
        columnFour, //True or false to active four column
        columnFive, //True or false to active five actions column
        widthColumnOne, //width column 1
        widthColumnTwo, //width column 2
        widthColumnThree, //width column 3
        widthColumnFour, //width column 4
        widthColumnFive, //width column 5
        titleRow1, //Header first column
        titleRow2, //Header second column
        titleRow3, //Header third column
        titleRow4, // Header fourth column
        titleRow5, // Header five column
        headerColumnOne, //header´s style in column 1
        headerColumnTwo, //header´s style in column 2
        headerColumnThree, //header´s style in column 3
        headerColumnFour, //header´s style in column 4
        cellColumnOne, //cell for column 1
        cellColumnTwo, //cell for column 2
        cellColumnThree, //cell for column 3
        cellColumnFour, //cell for column 4
        pageable = true,
        styleGrid,
        setShowDetails, //True or false, show detail
        setNameComponentUser, //Name item actions, section
        iconOneActiveSelected, //Active one button item, True or false if you use value from array
        iconOneActive, //Active section/item actions, fisrt item action
        iconTwoActive, //Active section/item actions, second item action
        iconTwoActiveSelected, //Active one button item, True or false if you use value from array
        iconThirdActive, //Active section/item actions, third item action
        iconFourthActive, //Active section/item actions, four item action
        labelOneActions, //Label fisrt item action
        labelTwoActions, //Label second item action
        labelTwoActions2, // Label second option text to action column
        labelThirdActions, //Label third item action
        labelFourthActions, //Label fourth item action
        activeDialog1, //True to function active dialog and false to change page
        btnOpenDialog1, //Function to open dialog in cellAction
        showDialogYesNo, //Value true or false, to dialog
        activeDialog2, //Function to open dialog on second btn in cellAction
        btnOpenDialog2, //Function to open dialog on second btn in cellAction
        showDialogYesNo2, //Value true or false, to dialog on second btn
        paddingBtns, //True or false if want padding between btns
        onItemChange, // Function that updates data
        onRowClick,
        styleGeneral,
        styleGeneralClass,
        isCheckedColOne,
        onHeaderRowClick, //Function to click in month
        mobileFunction
    } = props;

    const { t } = useTranslation();

    const initialDataState = {
        skip,
        take,
    };

    const gridColumnNoRecordsStyle = {
        color: "#2C353C",
        fontSize: "16px",
        fontWeight: 550,
        fontFamily: "Quicksand",
    };


    const [page, setPage] = useState(initialDataState);
    const [selectedItem, setSelectedItem] = useState({});

    const onPageChange = (event) => {
        setPage(event.page);
    };

    useEffect(() => {
        if (!columnFive) return;
        onSelectedItem(selectedItem);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedItem]);

    useEffect(() => {
        setPage(initialDataState);
    }, [dataGrid]);

    return <div>
        <Grid
            className={styleGeneral === true ? styleGeneralClass : "gridSelectionHLPure"}
            data={(pageable === false) ? dataGrid : dataGrid.slice(page.skip, page.take + page.skip)}
            reorderable
            style={styleGrid}
            skip={page.skip}
            take={page.take}
            pageable={pageable}
            total={dataGrid.length}
            onPageChange={onPageChange}
            filter={filter}
            onChangeFilter={onFilterChange}
            onItemChange={onItemChange}
            onRowClick={onRowClick}
            onHeaderRowClick={onHeaderRowClick}
        >
            {
                columnOne ?
                    <Column
                        width={widthColumnOne}
                        title={titleRow1}
                        cell={cellColumnOne}
                        headerCell={headerColumnOne}
                        field={isCheckedColOne}
                    /> : null
            }
            {columnTwo ?
                <Column
                    title={titleRow2}
                    width={widthColumnTwo}
                    cell={cellColumnTwo}
                    headerCell={headerColumnTwo}
                />
                : ""
            }
            {
                columnThree ?

                    <Column
                        title={titleRow3}
                        cell={cellColumnThree}
                        headerCell={headerColumnThree}
                        width={widthColumnThree}
                    />
                    : ""
            }
            {
                columnFour ?
                    <Column
                        title={titleRow4}
                        cell={cellColumnFour}
                        headerCell={headerColumnFour}
                        width={widthColumnFour}
                    />
                    : ""
            }
            {
                columnFive ?
                    <Column
                        title={titleRow5}
                        cell={cellActions({
                            setSelectedItem: setSelectedItem,
                            props,
                            setShowDetails: setShowDetails,
                            setNameComponentUser: setNameComponentUser,
                            iconOneActiveSelected,
                            iconOneActive,
                            iconTwoActive,
                            iconTwoActiveSelected,
                            iconThirdActive,
                            iconFourthActive,
                            labelOneActions,
                            labelTwoActions,
                            labelTwoActions2,
                            labelThirdActions,
                            labelFourthActions,
                            activeDialog1,
                            btnOpenDialog1,
                            showDialogYesNo,
                            activeDialog2,
                            btnOpenDialog2,
                            showDialogYesNo2,
                            paddingBtns,
                            mobileFunction
                        })}
                        width={widthColumnFive}
                    />
                    : ""
            }
            <GridNoRecords>
                <span style={gridColumnNoRecordsStyle}>
                    {t("configurationDomainPanel.notResults")}
                </span>
            </GridNoRecords>
        </Grid>
    </div>;
};
export { GridSelectionHLPure as default };
